import AppContext from "PFApp/app_context";
import { GrowlProps } from "PFComponents/growl";
import { GROWL_ACTIONS } from "PFCore/reducers/growl_reducer";
import { useCallback, useContext } from "react";

export const useGrowl = () => {
  const { dispatch } = useContext(AppContext);

  return useCallback(
    (payload: GrowlProps) => {
      dispatch({
        type: GROWL_ACTIONS.GROWL_RENDER,
        payload
      });
    },
    [dispatch]
  );
};
